import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useTesteService() {
  const { authenticatedFetch } = useApi();

  const criarTeste = async (dados) => {
    const response = await authenticatedFetch(URLS.CREATE_TESTE, {
      method: 'POST',
      body: JSON.stringify(dados),
    });
    return response.json();
  };

  const atualizarTeste = async (dados) => {
    const response = await authenticatedFetch(URLS.UPDATE_TESTE, {
      method: 'POST',
      body: JSON.stringify(dados),
    });
    return response.json();
  };

  const deletarTeste = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_TESTE, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return response.json();
  };

  const listarTestes = async () => {
    const response = await authenticatedFetch(URLS.READ_ALL_TESTE);
    return response.json();
  };

  const obterTestePorId = async (id) => {
    const response = await authenticatedFetch(URLS.READ_BY_TESTE_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return response.json();
  };

  const listarProdutosDoTeste = async (idTeste) => {
    const response = await authenticatedFetch(URLS.READ_PRODUTO_TESTE_BY_TEST_ID, {
      method: 'POST',
      body: JSON.stringify({ idTeste }),
    });
    return response.json();
  };

  return {
    criarTeste,
    atualizarTeste,
    deletarTeste,
    listarTestes,
    obterTestePorId,
    listarProdutosDoTeste
  };
}